import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'
import { EMPTY_BOARD_RECURRING_TASKS_BOARD_STATE } from './boardRecurringTasks.state.utils'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerBoardRecurringTasks = (
  state: AppState,
  boardId: number | null,
) => {
  if (boardId == null) return EMPTY_BOARD_RECURRING_TASKS_BOARD_STATE

  return (
    state.taskTracker.boardRecurringTasks.byBoardId[boardId] ??
    EMPTY_BOARD_RECURRING_TASKS_BOARD_STATE
  )
}
